var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3582 14.4138C19.7894 14.1407 20.0521 13.667 20.0555 13.1566C20.0589 12.6462 19.8026 12.1691 19.3751 11.8903L3.8195 1.74365C3.35842 1.44289 2.76964 1.41887 2.28559 1.68105C1.80154 1.94324 1.5 2.4495 1.5 3V23C1.5 23.5469 1.79766 24.0505 2.27681 24.3142C2.75596 24.5778 3.34065 24.5598 3.80267 24.2672L19.3582 14.4138Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.f992f87cdcb45894b4b720107ecabf71.svg";
export { ForwardRef as ReactComponent };